import { useEffect, useState } from 'react';
import api, { setUploadPolicy } from '../lib/api';

let cache = null;
let inflight = null;
const load = () => {
  inflight = inflight || api.get('/api/portal/config').then((r) => { cache = r.data; setUploadPolicy(r.data.uploads); return r.data; }).catch(() => null).finally(() => { inflight = null; });
  return inflight;
};

// Effective Settings → Client Portal config for the current entity (modules, upload limits, topics, FY).
export const usePortalConfig = (enabled = true) => {
  const [cfg, setCfg] = useState(cache);
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    const refresh = () => { cache = null; load().then((d) => alive && setCfg(d)); };
    load().then((d) => alive && setCfg(d));
    window.addEventListener('kv-entity-changed', refresh);
    return () => { alive = false; window.removeEventListener('kv-entity-changed', refresh); };
  }, [enabled]);
  return cfg;
};
